import { Link } from 'react-router-dom';
import clsx from 'clsx';
import type { Vendor } from '@shopgnd/shared';
import { VerifiedBadge } from '@/components/VerifiedBadge';
import { vendorStorePath } from '@/lib/vendorUrl';

export function VendorName({
  vendor,
  className,
  badgeSize = 'sm',
  badgeVariant = 'default',
  asLink = true,
}: {
  vendor: Pick<Vendor, 'slug' | 'businessName' | 'verified'>;
  className?: string;
  badgeSize?: 'sm' | 'md' | 'lg';
  badgeVariant?: 'default' | 'onDark';
  asLink?: boolean;
}) {
  const inner = (
    <>
      <span className="truncate">{vendor.businessName}</span>
      {vendor.verified ? <VerifiedBadge size={badgeSize} variant={badgeVariant} /> : null}
    </>
  );

  const styles = clsx('inline-flex max-w-full items-center gap-1.5', className);

  if (asLink) {
    return (
      <Link to={vendorStorePath(vendor)} className={styles}>
        {inner}
      </Link>
    );
  }

  return <span className={styles}>{inner}</span>;
}
